export const FREE_CHIP_NAMES = {
  freeChipsList: 'FREE_CHIPS_LIST',
  freeChipEnded: 'FREE_CHIP_ENDED',
  freeChipWin: 'FREE_CHIP_WIN',
  freeChipInfo: 'FREE_CHIP_INFO',
};

export const FREE_CHIP_POPUP_T_KEYS = {
  FREE_CHIPS_LIST: 'FREE_CHIP',
  FREE_CHIP_INFO: 'FREE_CHIP_INFO',
  FREE_CHIP_WIN: 'FREE_CHIPS_IN_COST',
  FREE_CHIP_ENDED: 'FREE_CHIP_HAS_ENDED',
};

export const FREE_BET_STATUS = {
  Unknown: 0,
  Pending: 1,
  Accepted: 2,
  Finished: 3,
  Expired: 4,
};

export const FREE_BET_ENDED_METHOD_NAME = 'FreeBetEnded';

export const FREE_BET_AWARDED_METHOD_NAME = 'FreeBetAwarded';
